import { yupResolver } from '@hookform/resolvers/yup'
import Container from '@mui/material/Container'

import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import uniqBy from 'lodash/uniqBy'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { connect, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { useRef, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import PhishCampaignSmsCreateFormFollowUp from './PhishCampaignSmsCreateFormFollowUp'
import PhishCampaignSmsCreateFormGeneral from './PhishCampaignSmsCreateFormGeneral'
import combineDateTime from '../../libs/utils/combineDateTime'

const mapStateToProps = () => ({})

const PhishCampaignSmsCreate = ({ dispatch }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const itemRefs = useRef([])

  const [createList, setCreateList] = useState([])

  const companyId = useSelector(state => state.auth.account?.companyId)

  Yup.addMethod(Yup.date, 'minStartDate', function testStartDate(errorMessage1, errorMessage2) {
    return this.test('test-start-date', (errorMessage1, errorMessage2), (_, context) => {
      const { parent = {}, path, createError } = context

      const { startDate, startTime, dateRangeType } = parent

      const isStartFixed = isEqual(dateRangeType, '1')
      const startDateTime = combineDateTime(startDate, startTime)

      // 20240418 if now is 11:00 ensure when I set time is 11:15 can be pass validation
      // remamber can't use isSameOrAfter this function that time must after 15 minutes.
      // meaning if now is 11:00, your select time must 11:16
      if (moment(startDateTime).isAfter(moment().add(14, 'minutes')) && !isStartFixed) {
        return true
      }
      if (moment(startDateTime).isAfter(moment().subtract(1, 'minutes')) && isStartFixed) {
        return true
      }

      // isStartFixed === true === now, isStartFixed === false === + 15 minutes
      return isStartFixed
        ? createError({ path, message: errorMessage2 })
        : createError({ path, message: errorMessage1 })
    })
  })

  Yup.addMethod(Yup.date, 'afterStartDate', function testEndDate(errorMessage) {
    return this.test('test-end-date', errorMessage, (_, context) => {
      const { parent = {}, path, createError } = context

      const { startDate, startTime, endDate, endTime } = parent

      const startDateTime = combineDateTime(startDate, startTime)
      const endDateTime = combineDateTime(endDate, endTime)

      if (moment(endDateTime).isSameOrAfter(moment(startDateTime).add(1, 'days'))) {
        return true
      }

      return createError({ path, message: errorMessage })
    })
  })

  Yup.addMethod(Yup.string, 'courseId', function testCourseId(errorMessage) {
    return this.test('test-course-id', errorMessage, (_, context) => {
      const { parent = {}, path, createError } = context

      const { checkFollowUp, courseId } = parent

      if (!checkFollowUp) {
        return true
      }

      if (!isEmpty(courseId)) {
        return true
      }

      return createError({ path, message: errorMessage })
    })
  })

  Yup.addMethod(Yup.object, 'smsTemplate', function testEmailTemplate(errorMessage) {
    return this.test('test-sms-template', errorMessage, (_, context) => {
      const { parent = {}, path, createError } = context

      const { phishType, smsTemplate } = parent

      if (phishType === 'R') {
        return true
      }

      if (!isEmpty(smsTemplate)) {
        return true
      }

      return createError({ path, message: errorMessage })
    })
  })

  Yup.addMethod(Yup.object, 'smsTemplateLabel', function testEmailTemplateLabel(errorMessage) {
    return this.test('test-sms-template-label', errorMessage, (_, context) => {
      const { parent = {}, path, createError } = context

      const { phishType, smsTemplateLabel } = parent

      if (phishType !== 'R') {
        return true
      }

      if (!isEmpty(smsTemplateLabel)) {
        return true
      }

      return createError({ path, message: errorMessage })
    })
  })

  Yup.addMethod(Yup.object, 'landingPage', function testLandingPage(errorMessage) {
    return this.test('test-landing-page', errorMessage, (_, context) => {
      const { parent = {}, path, createError } = context

      const { landingType, landingPage } = parent

      if (landingType === 'default') {
        return true
      }

      if (!isEmpty(landingPage)) {
        return true
      }

      return createError({ path, message: errorMessage })
    })
  })

  Yup.addMethod(Yup.array, 'checkReminderDates', function testReminderDate(errorMessage) {
    return this.test('test-reminder-date', errorMessage, (_, context) => {
      const { parent = {}, path, createError } = context

      const {
        checkFollowUp,
        startDate,
        endDate,
        startTime,
        endTime,
        reminderScheduleList = [],
      } = parent

      if (!checkFollowUp) {
        return true
      }

      const startDateTime = combineDateTime(startDate, startTime)
      const endDateTime = combineDateTime(endDate, endTime)

      const error = createError({ path, message: errorMessage })

      const outofRangeDate = reminderScheduleList.find(
        d =>
          !moment(d).isBetween(
            moment(startDateTime).endOf('date'),
            moment(endDateTime).startOf('date'),
            undefined,
            '{}',
          ),
      )

      if (outofRangeDate) {
        return error
      }

      const hasDuplicate =
        uniqBy(reminderScheduleList, element => element.getTime()).length !==
        reminderScheduleList.length

      if (hasDuplicate) {
        return error
      }

      return true
    })
  })

  const validations = {
    name: Yup.string().required(t('validation.campaign_name_required')),
    testCompany: Yup.object()
      .required(t('validation.test_company_required'))
      .typeError(t('validation.test_company_required')),
    courseId: Yup.string().courseId(t('validation.course_required')),
    // reminderScheduleList: Yup.array().checkReminderDates(t('validation.reminder_dates')),
  }

  const form = useForm({
    resolver: yupResolver(Yup.object().shape(validations)),
  })

  const { getValues, watch } = form

  const checkFollowUp = watch('checkFollowUp')

  const onTestsubmit = () => {
    const TestPhishCampaign = []
    const formValues = getValues()

    const { campaignType, testCompany } = formValues

    itemRefs.current?.forEach?.(r => {
      const childFormValues = r.form?.getValues?.() || {}

      const {
        smsTemplate,
        smsTemplateLabel,
        endDate,
        endTime,
        landingPage,
        landingType,
        phishType,
        startDate,
        startTime,
      } = childFormValues

      const isPhishRandom = phishType === 'R'
      const isLandingDefault = landingType === 'default'

      const startDateTime = combineDateTime(startDate, startTime)
      const endDateTime = combineDateTime(endDate, endTime)

      TestPhishCampaign.push({
        type: campaignType,
        tempModel: phishType,
        phishSmsType: isPhishRandom ? 'labelId' : 'templateId',
        ...(isPhishRandom
          ? { phishSmsLabelId: smsTemplateLabel.id }
          : { phishSmsTempId: smsTemplate.id }),
        landingpageType: isLandingDefault ? 'default' : 'templateId',
        ...(isLandingDefault ? {} : { landingpageTempId: landingPage.id }),
        scheduledStartTime: startDateTime,
        scheduledEndlTime: endDateTime,
        timeModel: 1, // sms didn't have sending time this function so give default value 1
        testCompanyName: testCompany.label,
      })
    })

    dispatch({
      type: 'phishCampaign/sendPhishCampaignTest',
      payload: {
        TestPhishCampaign,
      },
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: {
            message: t('messages.test_campaign_sent'),
            severity: 'success',
          },
        })
      },
      errorCallback: err => {
        dispatch({
          type: 'app/notify',
          payload: { message: err, severity: 'error' },
        })
      },
    })
  }

  const onSubmit = () => {
    const campaignList = []
    const formValues = getValues()

    const {
      attachmentOpen,
      campaignType,
      campaignRunType,
      dataEntered,
      followUpAction,
      linkClicked,
      name,
      testCompany,
      courseName,
      courseId,
      completeNotify,
      reminderNotify,
      sendInvite,
      reminderScheduleList,
    } = formValues

    itemRefs.current?.forEach?.(r => {
      const childFormValues = r.form?.getValues?.() || {}

      const {
        name: childName,
        smsTemplate,
        smsTemplateLabel,
        endDate,
        endTime,
        landingPage,
        // landingPageLabel,
        landingType,
        // phishEmailLabelType,
        phishType,
        startDate,
        startTime,
        userGroup,
      } = childFormValues

      const isPhishRandom = phishType === 'R'
      const isLandingDefault = landingType === 'default'

      const startDateTime = combineDateTime(startDate, startTime)
      const endDateTime = combineDateTime(endDate, endTime)

      const followUpActions = []

      if (linkClicked) {
        followUpActions.push(1)
      }

      if (dataEntered) {
        followUpActions.push(2)
      }

      if (attachmentOpen) {
        followUpActions.push(3)
      }

      campaignList.push({
        campaignName: createList.length === 1 ? name : childName,
        type: campaignType,
        tempModel: phishType,
        userGroupId: userGroup.id,
        phishSmsType: isPhishRandom ? 'labelId' : 'templateId',
        ...(isPhishRandom
          ? { phishSmsLabelId: smsTemplateLabel.id }
          : { phishSmsTempId: smsTemplate.id }),
        landingpageType: isLandingDefault ? 'default' : 'templateId',
        ...(isLandingDefault ? {} : { landingpageTempId: landingPage.id }),
        scheduledStartTime: startDateTime,
        scheduledEndlTime: endDateTime,
        // ...(followUpAction !== '1' ? { phishCampaignActionFollowUp: followUpActions } : {}),
        courseCampName: courseName,
        courseProgramId: courseId,
        notiCompleteOrNot: completeNotify,
        reminderOrNot: reminderNotify,
        ...(reminderNotify ? { remindTime: reminderScheduleList } : {}),
        invitationOrNot: sendInvite,
        timeModel: 1, // sms didn't have sending time this function so give default value 1
        testCompanyId: testCompany.id,
      })
    })

    dispatch({
      type: 'phishCampaign/createPhishCampaign',
      payload: {
        mainName: name,
        type: campaignType,
        runType: campaignRunType,
        companyId,
        testCompanyId: testCompany.id,
        campaignList,
      },
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: {
            message: t('messages.phish_campaign_created'),
            severity: 'success',
          },
        })
        navigate('/phish_campaign_sms', { replace: true })
      },
    })
  }

  return (
    <Container maxWidth={false}>
      {checkFollowUp ? (
        <PhishCampaignSmsCreateFormFollowUp form={form} onSubmit={onSubmit} />
      ) : (
        <PhishCampaignSmsCreateFormGeneral
          form={form}
          onSubmit={onSubmit}
          itemRefs={itemRefs}
          createList={createList}
          setCreateList={setCreateList}
          onTestsubmit={onTestsubmit}
        />
      )}
    </Container>
  )
}

export default connect(mapStateToProps)(PhishCampaignSmsCreate)
